import { Injectable, OnDestroy } from "@angular/core";
import mixpanel from "mixpanel-browser";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MixpanelService implements OnDestroy{
  private destroy$ = new Subject<void>();
  /**
   * Initialize mixpanel.
   *
   * @param {string} userToken
   * @memberof MixpanelService
   */
  init(userToken: string): void {

  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelService
   */
  track(id: string, action: any = {}): void {
    mixpanel.track(id, action);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
